import AOS from "aos";
import axios from "axios";
import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";

const Privacy = () => {
  const [privacydata, setPrivacydata] = useState(null)
  useEffect(() => {
    AOS.init({ duration: 1500, once: true });

    const loader = document.getElementById("preloader");
    if (loader) {
      setTimeout(() => {
        loader.style.display = "none";
      }, 1000); // 1 sec loader hide
    }
  }, []);

  useEffect(() => {
    featchPrivacy()
  }, [])
  const featchPrivacy = () => {
    axios.get(`${process.env.REACT_APP_BASE_URL}privacy_policy_list`)
      .then((result) => {
        const res = result.data.data;
        if (Array.isArray(res) && res.length > 0) {
          setPrivacydata(res[0]);
        }
      }).catch((err) => {
        console.log(err)
      });
  }

  return (
    <div>

      <div className="page_wrapper">
        {/* Preloader */}
        <div id="preloader">
          <div id="loader" />
        </div>
        {/* Header Start */}
        <header className="white_header">
          {/* container start */}
          <div className="container">
            {/* navigation bar */}
            <nav className="navbar navbar-expand-lg">
              <Link to={"/"} className="navbar-brand" >
                <img src="images/Logosmall.png" alt="image" />
              </Link>
              <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon">
                  {/* <i class="icofont-navigation-menu ico_menu"></i> */}
                  <div className="toggle-wrap">
                    <span className="toggle-bar" />
                  </div>
                </span>
              </button>
              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav ml-auto">
                  {/* secondery menu start */}
                  <li className="nav-item">
                    <Link to={"/"} className="nav-link" >Home</Link>
                  </li>
                  {/* secondery menu end */}
                </ul>
              </div>
            </nav>
            {/* navigation end */}
          </div>
          {/* container end */}
        </header>
        {/* BredCrumb-Section */}
        <div className="bred_crumb">
          <div className="container">
            {/* shape animation  */}
          </div>
        </div>
        {/* Why we are section Start */}
        <section className="row_am why_we_section" data-aos="fade-in">
          <div className="why_inner">
            <div className="container">
              <div
                className="section_title aos-init"
                data-aos="fade-up"
                data-aos-duration={1500}
                data-aos-delay={100}
              >
                <h2 style={{ color: 'black' }} >
                  {privacydata?.title}
                </h2>
                {privacydata?.description && (
         
                    <div
                        style={{ color: 'black' }}  
                      dangerouslySetInnerHTML={{
                        __html: privacydata.description
                          .replace(/<h1/g, '<h1 style="color: black;" font-size:25px')
                          .replace(/<h2/g, '<h2 style="color: black; font-size:25px"')
                          .replace(/<h3/g, '<h3 style="color: black; font-size:25px"'),
                      }}
                    />

                )}
                {/* <p>
                  Lorem Ipsum is simply dummy text of the printing and typese tting <br />{" "}
                  indus orem Ipsum has beenthe standard dummy.
                </p>
                <h4>1. Introduction</h4>
                <p>
                  Welcome to OriVeri Android an iOS application dedicated to providing product
                  authentication services. This Privacy Policy is designed to inform you about
                  the types of information we collect, how we use it, and the measures we take
                  to protect your privacy. By using our app, you consent to the practices
                  described in this policy.
                </p>
                <h4>Information We Collect</h4>
                <h5>User Provided Information</h5>
                <p>
                  When you use our app, we may collect the following types of personal
                  information: - Name - Email address - Contact information -
                  Authentication-related details
                </p>
                <h5>Automatically Collected Information</h5>
                <p>
                  We automatically collect certain information about your device and usage of
                  the app, including: - Device type and model - Operating system and version -
                  IP address - App usage statistics - Geolocation data (if enabled)
                </p>
                <h4>How We Use Your Information</h4>
                <b>We use the collected information for the following purposes:</b>
                <h5>Authentication and Verification</h5>
                <p>
                  We use your provided information for the primary purpose of authenticating
                  and verifying products submitted through the app.
                </p>
                <h5>Service Improvement</h5>
                <p>
                  We analyze user data to enhance our app's functionality, user experience,
                  and to identify areas for improvement.
                </p>
                <h5>Communication</h5>
                <p>
                  We may use your contact information to send you updates, newsletters, and
                  promotional material. You can opt-out of these communications at any time.
                </p>
                <h5>Security</h5>
                <p>
                  Your information is crucial for securing the authentication process, and we
                  employ robust security measures to protect it from unauthorized access,
                  disclosure, alteration, and destruction.
                </p>
                <h4>Data Sharing and Third-Party Services</h4>
                <p>
                  We do not sell, trade, or share your personal information with third parties
                  for their marketing purposes. However, we may share your information with
                  trusted third-party service providers that assist us in delivering our
                  services, such as analytics, hosting, and authentication services.
                </p>
                <h4> Your Choices and Controls</h4>
                <p>
                  You have the following choices regarding your data:- You can review and
                  update your account information.
                </p>
                <h4>Children's Privacy</h4>
                <p>
                  Our app is not directed at individuals under the age of 13. We do not
                  knowingly collect personal information from children. If you believe that we
                  have inadvertently collected information from a child, please contact us to
                  have it removed.
                </p>
                <h4>Changes to This Privacy Policy</h4>
                <p>
                  We reserve the right to modify this Privacy Policy at any time. Any changes
                  will be effective immediately upon posting the updated policy. We will
                  notify you of significant changes through the app or via the contact
                  information provided by you.
                </p>
                <h4>Contact Us</h4>
                <p>
                  If you have questions or concerns about our Privacy Policy, please contact
                  us at <b> info@oriveri.com </b>
                  By using our app, you acknowledge that you have read and understood this
                  Privacy Policy.
                </p> */}
              </div>

            </div>
          </div></section>
        {/* Footer-Section start */}
        <footer>
          <div className="top_footer" id="contact">
            {/* animation line */}
            <div className="anim_line dark_bg">
              <span><img src="images/anim_line.png" alt="anim_line" /></span>
              <span><img src="images/anim_line.png" alt="anim_line" /></span>
              <span><img src="images/anim_line.png" alt="anim_line" /></span>
              <span><img src="images/anim_line.png" alt="anim_line" /></span>
              <span><img src="images/anim_line.png" alt="anim_line" /></span>
              <span><img src="images/anim_line.png" alt="anim_line" /></span>
              <span><img src="images/anim_line.png" alt="anim_line" /></span>
              <span><img src="images/anim_line.png" alt="anim_line" /></span>
              <span><img src="images/anim_line.png" alt="anim_line" /></span>
            </div>
            {/* container start */}
            <div className="container">
              {/* row start */}
              <div className="row">
                {/* footer link 1 */}
                <div className="col-lg-4">
                  <div className="abt_side">
                    <div className="logo">
                      <img src="images/Logosmall.png" alt="image" />
                    </div>
                    <ul>
                      <li>
                        <a href="#">info@oriveri.com</a>
                      </li>
                      {/* <li><a href="#">+1-900-123 4567</a></li> */}
                    </ul>
                    <ul className="social_media">
                      <li>
                        <a href="#">
                          <i className="icofont-facebook" />
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <i className="icofont-linkedin" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* footer link 3 */}
                <div className="col-lg-3">
                  <div className="links">
                    <ul>
                      <li>
                        <Link to="/contactowner" style={{ color: "yellow", fontWeight: "bold" }}>
                          For Brand Owners
                        </Link>
                      </li>
                      <li>
                        <Link to="/scanqr" style={{ color: "yellow", fontWeight: "bold" }}>
                          Scan Qr
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>

                {/* footer link 2 */}
                <div className="col-lg-3">
                  <div className="links">
                    <ul>
                      <li>
                        <Link to="/contact">Contact us</Link>
                      </li>
                      <li>
                        <Link to="/terms&conditions">Terms &amp; conditions</Link>
                      </li>
                      <li>
                        <Link to="/privacy">Privacy policy</Link>
                      </li>
                    </ul>
                  </div>
                </div>



                {/* footer link 4 */}
                <div className="col-lg-2">
                  <div className="try_out">
                    <div
                      style={{ borderRadius: "10px 10px 0px 0px" }}
                      className="responsive_div"
                    >
                      <h4 className="responsive_heading">
                        <b>Download</b> the <b>Application</b> for a{" "}
                        <b>Secured</b>, <b>Swift</b>, and <b>Smooth experience</b>!
                      </h4>
                      <ul style={{ marginBottom: "0px" }} className="app_btn">
                        <li>
                          <a href="https://apps.apple.com/us/app/oriveri/id6741198221">
                            <img src="images/appstore_blue.png" alt="App Store" />
                          </a>
                        </li>
                        <li>
                          <a href="https://play.google.com/store/apps/details?id=com.oriveri.com">
                            <img
                              style={{ padding: "3px" }}
                              src="images/googleplay_blue.png"
                              alt="Google Play"
                            />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/* row end */}
            </div>
            {/* container end */}
          </div>
          {/* last footer */}
          <div className="bottom_footer">
            {/* container start */}
            <div className="container">
              {/* row start */}
              <div className="row">
                <div className="col-md-6">
                  <p>© Copyrights 2025. All rights reserved.</p>
                </div>
                <div className="col-md-6">
                  <p className="developer_text">Design &amp; developed by <a href="https://themeforest.net/user/kalanidhithemes" target="blank">Logical Softtech Pvt. Ltd.</a></p>
                </div>
              </div>
              {/* row end */}
            </div>
            {/* container end */}
          </div>
          {/* go top button */}
          <div className="go_top">
            <span><img src="images/go_top.png" alt="image" /></span>
          </div>
        </footer>
        {/* Footer-Section end */}
        {/* VIDEO MODAL */}
        <div className="modal fade youtube-video" id="myModal" tabIndex={-1} role="dialog" aria-labelledby="myModalLabel">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <button id="close-video" type="button" className="button btn btn-default text-right" data-dismiss="modal">
                <i className="icofont-close-line-circled" />
              </button>
              <div className="modal-body">
                <div id="video-container" className="video-container">
                  <iframe id="youtubevideo" src="#" width={640} height={360} frameBorder={0} allowFullScreen />
                </div>
              </div>
              <div className="modal-footer">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Privacy